import api from './client';

const BASE = '/api/payment-types';

export async function fetchPaymentTypes(config = {}) {
  const { data } = await api.get(BASE, config);
  return Array.isArray(data) ? data : [];
}

export async function createPaymentType(payload, config = {}) {
  const { data } = await api.post(BASE, payload, config);
  return data;
}

export async function updatePaymentType(id, payload, config = {}) {
  const { data } = await api.put(`${BASE}/${id}`, payload, config);
  return data;
}

export async function deletePaymentType(id, config = {}) {
  await api.delete(`${BASE}/${id}`, config);
}
